module.exports = __webpack_public_path__ + "img/icon-plus.d13f859f.svg";